/* Mobeess UX fixes (theme copy) */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---- move the WhatsApp "ask us" link under the purchase buttons ---- */
  function moveWhatsApp() {
    document.querySelectorAll('.product__info-container a.whatsapp-btn').forEach(function (a) {
      if (a.dataset.mobeessMoved) return;
      var info = a.closest('.product__info-container');
      var buttons = info && info.querySelector('.product-form__buttons');
      if (!buttons) return;
      a.dataset.mobeessMoved = '1';
      var wrap = document.createElement('div');
      wrap.className = 'mobeess-wa-link';
      wrap.appendChild(a);
      buttons.insertAdjacentElement('afterend', wrap);
    });
  }

  /* ---- collection description "read more" ---- */
  function initClamp() {
    document.querySelectorAll('[data-mobeess-clamp]').forEach(function (el) {
      if (el.dataset.clampInit) return;
      el.dataset.clampInit = '1';
      el.classList.add('is-clamped');
      var btn = el.parentElement.querySelector('[data-mobeess-clamp-toggle]');
      if (!btn) return;
      if (el.scrollHeight - el.clientHeight > 4) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var open = el.classList.toggle('is-clamped') === false;
          btn.textContent = open ? 'הצג פחות' : 'קראו עוד';
        });
      } else {
        el.classList.remove('is-clamped');
      }
    });
  }

  /* ---- cart upsell ---- */
  function loadUpsell(container, productId, limit) {
    if (!container || !productId) return;
    var url = root + 'recommendations/products?product_id=' + productId + '&limit=10&intent=related&section_id=mobeess-cart-upsell';
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.mobeess-upsell__inner');
        if (!inner || !inner.querySelector('.mobeess-upsell__item')) { container.innerHTML = ''; return; }
        if (limit) inner.querySelectorAll('.mobeess-upsell__item').forEach(function (li, i) { if (i >= limit) li.remove(); });
        if (container.classList.contains('mobeess-upsell--compact')) {
          inner.querySelectorAll('.mobeess-upsell__add--link').forEach(function (a) { a.textContent = 'לבחירה'; });
        }
        container.innerHTML = inner.outerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mobeess-upsell__add[data-variant-id]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.textContent = 'מוסיף…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.variantId), quantity: 1 }] })
    }).then(function (r) {
      if (r.ok) { window.location.href = root + 'cart'; }
      else { b.disabled = false; b.textContent = 'הוסף לסל'; }
    }).catch(function () { b.disabled = false; b.textContent = 'הוסף לסל'; });
  });

  function initUpsell() {
    document.querySelectorAll('[data-mobeess-upsell][data-product-id]').forEach(function (el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      loadUpsell(el, el.dataset.productId, Number(el.dataset.limit) || 4);
    });
    var notif = document.getElementById('cart-notification');
    var slot = document.querySelector('[data-mobeess-upsell-notification]');
    if (notif && slot && !notif.dataset.mobeessObs) {
      notif.dataset.mobeessObs = '1';
      new MutationObserver(function () {
        if (!notif.classList.contains('active')) return;
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.items && cart.items.length) loadUpsell(slot, cart.items[0].product_id, 3);
          })
          .catch(function () {});
      }).observe(notif, { attributes: true, attributeFilter: ['class'] });
    }
  }

  var waTimer;
  function watchProductInfo() {
    document.querySelectorAll('product-info').forEach(function (p) {
      if (p.dataset.mobeessWatch) return;
      p.dataset.mobeessWatch = '1';
      new MutationObserver(function () { clearTimeout(waTimer); waTimer = setTimeout(moveWhatsApp, 60); })
        .observe(p, { childList: true, subtree: true });
    });
  }

  /* ---- collections: one page, in-stock first, sold-out last (across ALL pages) ---- */
  function mergeAllPages(marker) {
    if (marker.dataset.started) return;
    marker.dataset.started = '1';
    var grid = marker.parentElement && marker.parentElement.querySelector('#product-grid');
    if (!grid) return;
    var pages = Number(marker.dataset.pages) || 1;
    var current = Number(marker.dataset.current) || 1;
    var base = new URL(marker.dataset.baseUrl || window.location.href, window.location.origin);
    base.searchParams.set('section_id', marker.dataset.sectionId);
    grid.classList.add('mobeess-loading-all');
    var byPage = {};
    byPage[current] = Array.prototype.slice.call(grid.children);
    var todo = [];
    for (var p = 1; p <= pages; p++) if (p !== current) todo.push(p);

    function fetchPage(p) {
      var u = new URL(base.toString());
      u.searchParams.set('page', p);
      return fetch(u.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.getElementById('product-grid');
          byPage[p] = g ? Array.prototype.slice.call(g.children) : [];
        })
        .catch(function () { byPage[p] = []; });
    }
    // small concurrency pool
    var i = 0;
    function worker() { if (i >= todo.length) return Promise.resolve(); var p = todo[i++]; return fetchPage(p).then(worker); }
    Promise.all([worker(), worker(), worker()]).then(function () {
      if (!grid.isConnected) return;
      var inStock = [], soldOut = [];
      for (var q = 1; q <= pages; q++) {
        (byPage[q] || []).forEach(function (li) {
          if (li.nodeType !== 1) return;
          li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          (li.getAttribute('data-mobeess-available') === 'false' ? soldOut : inStock).push(li);
        });
      }
      var frag = document.createDocumentFragment();
      inStock.concat(soldOut).forEach(function (li) { frag.appendChild(li.ownerDocument === document ? li : document.importNode(li, true)); });
      grid.innerHTML = '';
      grid.appendChild(frag);
      grid.classList.remove('mobeess-loading-all');
      grid.dataset.mobeessCount = inStock.length + soldOut.length;
      marker.remove();
      document.dispatchEvent(new CustomEvent('mobeess:collection-merged', { detail: { inStock: inStock.length, soldOut: soldOut.length } }));
    });
  }
  function initAllPages() {
    document.querySelectorAll('[data-mobeess-allpages]').forEach(mergeAllPages);
  }
  function watchFacets() {
    var c = document.getElementById('ProductGridContainer');
    if (!c || c.dataset.mobeessWatch) return;
    c.dataset.mobeessWatch = '1';
    new MutationObserver(function () { initAllPages(); }).observe(c, { childList: true, subtree: true });
  }

  /* ---- perf: warm up images just before they are needed ---- */
  function eagerize(scope) {
    if (!scope) return;
    scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  function initWarmup() {
    // mega menu: start loading panel images on first intent (pointer over the menu bar / keyboard focus)
    var bar = document.querySelector('.header__inline-menu');
    if (bar && !bar.dataset.warm) {
      bar.dataset.warm = '1';
      var go = function () { eagerize(bar); bar.removeEventListener('pointerenter', go); bar.removeEventListener('focusin', go); };
      bar.addEventListener('pointerenter', go);
      bar.addEventListener('focusin', go);
    }
    // mobile drawer: warm first-level thumbnails when the hamburger is touched; submenu images when a row is touched
    var drawer = document.querySelector('header-drawer');
    if (drawer && !drawer.dataset.warm) {
      drawer.dataset.warm = '1';
      drawer.addEventListener('pointerdown', function (e) {
        var d = e.target.closest('details');
        eagerize(d || drawer);
      }, { passive: true });
    }
    // hero slider: hidden slides are lazy, so they popped in late on rotation; fetch them once the page has loaded
    var warmHero = function () {
      document.querySelectorAll('[class*="ai-promo-slider"] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    };
    if (document.readyState === 'complete') setTimeout(warmHero, 1500); else window.addEventListener('load', function () { setTimeout(warmHero, 1500); });
  }

  function init() { moveWhatsApp(); watchProductInfo(); initClamp(); initUpsell(); initAllPages(); watchFacets(); initWarmup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
